import { backendServices } from '../../services';
import { RecursivePartial } from '../../types';

export function createFieldDictionaryLayoutViewModel(): RecursivePartial<backendServices.ViewModels.DocumentLayoutViewModel> {
    return {
        SupplierCompanyId: null,
        BusinessDocId: null,
        DraftBusinessDoc: false,
        Layouts: [
            {
                ScreenSize: 1,
                ScreenSize_US: 'Large',
                Cells: [
                    {
                        FieldDictionaryLayoutCellId: null,
                        Section: 1,
                        Section_US: 'Header',
                        SectionXPath: '//BusinessDocument',
                        SectionJSONPath: '..BusinessDocument',
                        Column: 1,
                        Row: 1,
                        CellXPath: 'SIMDocument',
                        CellJSONPath: 'SIMDocument',
                        CellTitle: null,
                        AutoBalanceGroupName: 'Main Header Group',
                        MergeCellToRight: null,
                        Fields: [],
                        Cells: [],
                    },
                ],
            },
            {
                ScreenSize: 2,
                ScreenSize_US: 'Medium',
                Cells: [
                    {
                        FieldDictionaryLayoutCellId: null,
                        Section: 1,
                        Section_US: 'Header',
                        SectionXPath: '//BusinessDocument',
                        SectionJSONPath: '..BusinessDocument',
                        Column: 1,
                        Row: 1,
                        CellXPath: 'SIMDocument',
                        CellJSONPath: 'SIMDocument',
                        CellTitle: null,
                        AutoBalanceGroupName: 'Main Header Group',
                        MergeCellToRight: null,
                        Fields: [],
                        Cells: [],
                    },
                ],
            },
            {
                ScreenSize: 3,
                ScreenSize_US: 'Small',
                Cells: [
                    {
                        FieldDictionaryLayoutCellId: null,
                        Section: 1,
                        Section_US: 'Header',
                        SectionXPath: '//BusinessDocument',
                        SectionJSONPath: '..BusinessDocument',
                        Column: 1,
                        Row: 1,
                        CellXPath: 'SIMDocument',
                        CellJSONPath: 'SIMDocument',
                        CellTitle: null,
                        AutoBalanceGroupName: 'Main Header Group',
                        MergeCellToRight: null,
                        Fields: [],
                        Cells: [],
                    },
                ],
            },
        ],
    };
}
